export default "__VITE_ASSET__CyH0BSzp__"